import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline } from 'react-leaflet';
import L, { DivIcon, icon, Icon } from 'leaflet';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import {useLocationContext} from '../../contextapi/LocationContext'
import { light } from '@mui/material/styles/createPalette';
import { useGetLocation } from '../../contextapi/SendLcationContaxt';


const MapCustom = ({ users, routes, trucks ,zoom=8,center=[37.7577, -122.4376]}) => {







  const createUserDivIcon = (item) => {
    return new DivIcon({
      className: 'user-marker',
      html: `<div><img style="width:40px;height:40px;" src="${item.image}" alt="${item.text}" /><span>${item.text}</span></div>`,
      iconSize: [100, 60],
      iconAnchor: [50, 60],
      popupAnchor: [0, -60],
    });
  };
  
  
 
  
  return (
    <MapContainer center={center} zoom={zoom} style={{ height: '100%', width: '100%' }}>
      {/* <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      /> */}
        <ReactLeafletGoogleLayer apiKey='AIzaSyDy4ljqdxfiRqRongKkwLH5Y87oEkNTUVU'  />

   
      {users.map((user,index) => (
  <Marker key={user.id} position={[user.latitude, user.longitude]} 
  icon={createUserDivIcon({image:user.image,text:user.name})}>
    
    <Popup>{/* Render user info or popup content */}</Popup>
  </Marker>
))}
   
{  trucks && trucks.length>0 &&  Object.keys(trucks[0]).length > 0  &&  trucks?.map((truck,index) => (
  <Marker key={truck?.vehicle} position={[truck?.latitude, truck?.longitude]} 
  
  icon={createUserDivIcon({
    // image:truck.image,
    image:"https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/truck-256.png",
    text:truck.vehicle})}>
  
    <Popup>{/* Render truck info or popup content */}</Popup>
  </Marker>
))}


  

{routes.map((route) => (
        <Polyline key={route?.id} positions={route?.coordinates} color="blue" />
      ))}
    </MapContainer>
  );
};

const UserMap = ({preroutes}) => {

  const [Trucks,setTrucks]=useState([{}])
  const [Routes,setroutes]=useState([])

 

  // console.log(Routes,"Routes")

      
  const { locationData}=useGetLocation()

  // console.log(locationData,"locationData")
 


  const users = [
      {
        id: 1,
        name: 'User 1',
        image:"https://cdn4.iconfinder.com/data/icons/small-n-flat/24/user-512.png",
        latitude: 37.7749,
        longitude: -122.4194,
      },
      {
        id: 2,
        name: 'User 2',
        image:"https://cdn4.iconfinder.com/data/icons/small-n-flat/24/user-512.png",
        latitude: 37.8049,
        longitude: -122.4494,
      },
    ];



    
    
    const trucks = [
      {
        vehicle: 1,
        name: 'Truck 1',
        image:"https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/truck-256.png",
        type: 'delivery',
        latitude: 37.7649,
        longitude: -122.3894,
      },
      {
        vehicle: 2,
        name: 'Truck 2',
        image:"https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/truck-256.png",
        type: 'transport',
        latitude: 37.7649,
        longitude: -122.4094,
      },
    ];
    
    const routes = [
      {
        id: 1,
        name: 'Route 1',
        coordinates: 
        Routes
        //  [
        //   [37.8199, -122.4783], // Golden Gate Bridge
        //   [37.7986, -122.4012], // San Francisco Ferry Building
        //   [37.7947, -122.3999], // San Francisco Downtown
        //   [37.7931, -122.3985], // South of Market
        //   [37.7896, -122.3912], // Oracle Park
        //   [37.7652, -122.4048], // Potrero Hill
        //   [37.7524, -122.4183], // Bernal Heights
        //   [37.7374, -122.4132], // Daly City area
        // ],
       
      },
    ];
    
   
console.log(Trucks);



    // function updateOrAddObject(array, newObj) {
    //   const index = array.findIndex(item => item.vehicle === newObj.vehicle); 
    // console.log(index,"index")
    //   if (index !== -1) {
    //     const updatedArray = [...array];
    //     updatedArray[index] = { ...newObj };
    //     return updatedArray;
    //   } else {
       
    //     return [...array, { ...newObj }];
    //   }
    // }

    useEffect(() => {
   
      // const updatedTrucks = updateOrAddObject(Trucks, locationData);

      // setTrucks(locationData);

      if(Object.keys(locationData).length!==0){


        setTrucks([{...locationData}])
      }
    }, [locationData]);
    console.log(Trucks,"ooooooooooooooooo")
  
    // function updateOrAddObject(array=[], newObj) {

    //   console.log(newObj,'newObj')
    //   if(Object.keys(newObj).length!==0){
    //   const index = array.findIndex(item => item?.vehicle === newObj?.vehicle);

      
    //   if (index !== -1) {
    //     const updatedArray = [...array];

    //     updatedArray[index] = { ...newObj };
    //     return updatedArray;
    //   } else {
    //     return [...array, { ...newObj }];
    //   }
    // }
    // }

    // useEffect(()=>{
    //   updateOrAddObject(Trucks,locationData)
    // },[locationData])

    // console.log(routes,"trucks")



    useEffect(()=>{
     if(locationData.longitude&&locationData.latitude){
      const saveloc=()=>{
        setroutes((pre)=>[...pre,[locationData.latitude,locationData.longitude]]  )
      
      }
      saveloc()
     }
        },[locationData])


    useEffect(() => {
    if (preroutes.length > 0) {
        const filteredRoutes = preroutes.map(route => [route.latitude, route.longitude]);
        setroutes(prevRoutes => [...prevRoutes, ...filteredRoutes]);
    }
}, [preroutes]);

console.log(routes,"jkjkjkjkjk");

// function livedata(){
//   if(locationData.longitude&&locationData.latitude){
//     const movelive= [locationData.latitude,locationData.longitude]
//     console.log(movelive,"movelive")
//     return movelive
//   }else return [32.4677462,74.5152085]
// }
  

//    const jjjj=livedata()
console.log(Routes,"Routes");
console.log(preroutes,"Routes");
const mapFocuse=Routes[0]
console.log(mapFocuse,"mapFocuse");

if(Routes.length>0)
return (

  <MapCustom users={users} center={Routes[0]} zoom={12} routes={routes} trucks={Trucks}/>

)



}

const PhotoshootMap = () => {
  const users = [
      {
        id: 1,
        name: 'Photographer 1',
        image:"https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-camera-512.png",
        latitude: 37.7749,
        longitude: -122.4194,
      },
      {
        id: 2,
        name: 'Photographer 2',
        image:"https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-camera-512.png",
        latitude: 37.8049,
        longitude: -122.4494,
      },
    ];
    
    const trucks = [
      {
        vehicle: 1,
        name: 'Truck 1',
        image:"https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/truck-256.png",
        type: 'delivery',
        latitude: 37.7349,
        longitude: -122.3894,
      },
      {
        id: 2,
        name: 'Truck 2',
        image:"https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/truck-256.png",
        type: 'transport',
        latitude: 37.7649,
        longitude: -122.4094,
      },
    ];
    
    const routes = [
      {
        id: 1,
        name: 'Route 1',
        coordinates: [
          [37.8199, -122.4783], // Golden Gate Bridge
          [37.7986, -122.4012], // San Francisco Ferry Building
          [37.7947, -122.3999], // San Francisco Downtown
          [37.7931, -122.3985], // South of Market
          [37.7896, -122.3912], // Oracle Park
          [37.7652, -122.4048], // Potrero Hill
          [37.7524, -122.4183], // Bernal Heights
          [37.7374, -122.4132], // Daly City area
        ],
      },
    ];
    
    
return (

  <MapCustom users={users} center={[37.7649,-122.4200]} zoom={12} routes={routes} trucks={trucks}/>

)
}

export {MapCustom,UserMap,PhotoshootMap}